// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.timer-tool-container {
  max-width: 400px;
  margin: 2rem auto;
  background: rgba(0, 0, 0, 0.2);
  color: white;
  border-radius: 12px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
  padding: 2rem;
}

.timer-description {
  margin: 2rem;
}

.timer-remaining {
  margin: 1rem;
}

.timer-display {
  border: 1px grey solid;
  padding: 1rem;
  font-size: 2rem;
  margin: 1.5rem;
  text-align: center;
}

.timer-controls {
  display: flex;
  margin: 1.5rem;
  margin-top: 3rem;
  justify-content: center;
  gap: 1rem;
}

.timer-duration-label {
  font-size: 1.1rem;
}

.timer-duration-input {
  margin-left: 0.5rem;
  padding: 0.5rem;
  font-size: 1rem;
  width: 100px;
}

.timer-start-button {
  border: none;
  background-color: #449944;
  padding: 0.75rem 1.25rem;
  font-size: 1rem;
}

.timer-reset-button {
  border: none;
  background-color: #994444;
  padding: 0.75rem 1.25rem;
  font-size: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/TimerTool.css"],"names":[],"mappings":";AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,8BAA8B;EAC9B,YAAY;EACZ,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,wBAAwB;EACxB,eAAe;AACjB","sourcesContent":["\n.timer-tool-container {\n  max-width: 400px;\n  margin: 2rem auto;\n  background: rgba(0, 0, 0, 0.2);\n  color: white;\n  border-radius: 12px;\n  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);\n  padding: 2rem;\n}\n\n.timer-description {\n  margin: 2rem;\n}\n\n.timer-remaining {\n  margin: 1rem;\n}\n\n.timer-display {\n  border: 1px grey solid;\n  padding: 1rem;\n  font-size: 2rem;\n  margin: 1.5rem;\n  text-align: center;\n}\n\n.timer-controls {\n  display: flex;\n  margin: 1.5rem;\n  margin-top: 3rem;\n  justify-content: center;\n  gap: 1rem;\n}\n\n.timer-duration-label {\n  font-size: 1.1rem;\n}\n\n.timer-duration-input {\n  margin-left: 0.5rem;\n  padding: 0.5rem;\n  font-size: 1rem;\n  width: 100px;\n}\n\n.timer-start-button {\n  border: none;\n  background-color: #449944;\n  padding: 0.75rem 1.25rem;\n  font-size: 1rem;\n}\n\n.timer-reset-button {\n  border: none;\n  background-color: #994444;\n  padding: 0.75rem 1.25rem;\n  font-size: 1rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
